import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import reducer from './reducers';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {Router, Route, hashHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';

import App from './containers/App';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import NotFound from './components/NotFound';
import ForgotPassword from './components/ForgotPassword';
import Profile from './components/Profile';
import MerchantInfo from './components/MerchantInfo';
import MerchantInfoEdit from './components/MerchantInfo/edit';
import ProfileEdit from './components/Profile/edit';
import Perks from './components/Perks';
import PerksEditor from './components/Perks/editor';
import PerkView from './components/Perks/view';
import Customers from './components/Customers';
import Sign from './components/Sign';
import SignCheckEmail from './components/Sign/check_email';
import SignOwner from './components/Sign/owner';
import SignVerify from './components/Sign/verify';
import SignFinish from './components/Sign/finish';
import SignupVerify from './components/Sign/signup_verify';
import CheckCode from './components/Sign/check_code';
import SignError from './components/Sign/error';
import ErrorExpired from './components/Sign/error_expired';
import requireAuthentication from './components/AuthenticatedComponent';
import './styles/index.css';
import 'react-notifications/dist/react-notifications.css'
import 'react-select/dist/react-select.css';

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
const history = syncHistoryWithStore(hashHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route component={App}>
        <Route path="/" component={requireAuthentication(Dashboard)}/>
        <Route path="/dashboard" component={requireAuthentication(Dashboard)}/>
        <Route path="/login" component={Login}/>
        <Route path="/sign" component={Sign}/>
        <Route path="/sign/check_email" component={SignCheckEmail}/>
        <Route path="/sign/owner" component={SignOwner}/>
        <Route path="/sign/verify" component={SignVerify}/>
        <Route path="/sign/finish" component={SignFinish}/>
        <Route path="/sign/error" component={SignError}/>
        <Route path="/sign/error_expired" component={ErrorExpired}/>
        <Route path="/signup/verify/:token" component={SignupVerify}/>
        <Route path="/signup/check_code" component={CheckCode}/>
        <Route path="/forgot_password" component={ForgotPassword}/>
        <Route path="/profile" component={requireAuthentication(Profile)}/>
        <Route path="/merchant_info" component={requireAuthentication(MerchantInfo)}/>
        <Route path="/merchant_info/edit" component={requireAuthentication(MerchantInfoEdit)}/>
        <Route path="/profile/edit" component={requireAuthentication(ProfileEdit)}/>
        <Route path="/perks" component={requireAuthentication(Perks)}/>
        <Route path="/perks/add" component={requireAuthentication(PerksEditor)}/>
        <Route path="/perks/:id/edit" component={requireAuthentication(PerksEditor)}/>
        <Route path="/perks/:id/view" component={requireAuthentication(PerkView)}/>
        <Route path="/customers" component={requireAuthentication(Customers)}/>
        <Route path="*" component={NotFound}/>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/